<template>
    <router-link
        v-slot="{ href, navigate, isExactActive }"
        :to="to"
        custom
    >
        <li
            class="mb-0.5 rounded-sm px-3 py-2 last:mb-0"
            :class="isExactActive && 'bg-primary-700'"
        >
            <a
                class="block truncate text-gray-200 transition duration-150 hover:text-white"
                :class="isExactActive && 'hover:text-gray-100'"
                :href="href"
                @click="navigate"
            >
                <div class="flex items-center">
                    <div class="flex h-6 w-6 items-center justify-center">
                        <slot />
                    </div>
                    <span
                        class="lg:sidebar-expanded:block ml-3 text-sm font-medium duration-200 lg:hidden 2xl:block"
                        >{{ $t(label) }}</span
                    >
                </div>
            </a>
        </li>
    </router-link>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router'

defineProps<{
    label: string
    to: RouteLocationRaw
    counter?: number
}>()
</script>
